import React from 'react'

const Menu = () => {
    return (
        <ul>
            <li><a href="/#market">Crypto Market</a></li>
            <li><a href="/#choose-us">Choose Us</a></li>
            <li><a href="/#join-discord">Join Discord</a></li>
            <li><a href="https://www.coingecko.com/" target='_blank' rel='noreferrer'>CoinGecko API</a></li>
        </ul>
    )
}

export default Menu
